<template>
  <b-sidebar
    id="add-new-products-sidebar"
    :visible="isAddNewProductsSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-products-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Product aanmaken
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Name-->
          <validation-provider
            #default="validationContext"
            name="name"
            rules="required"
          >
            <b-form-group
              label="Naam"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="productsData.name"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Description-->
          <validation-provider
            #default="validationContext"
            name="description"
            rules="required"
          >
            <b-form-group
              label="Beschrijving"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                v-model="productsData.description"
                rows="3"
                no-resize
                maxlength="100"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Aanmaken
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Annuleren
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormTextarea, BSidebar,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { alphaNum, required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewProductsSidebarActive',
    event: 'update:is-add-new-products-sidebar-active',
  },
  props: {
    isAddNewProductsSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
    }
  },
  setup(props, { emit }) {
    const blankProductsData = {
      name: '',
      description: '',
      createTimestamp: '',
      active: 0,
      categoryID: null,
      policyCostSRD: null, // decimal
      policyCostUSD: null, // decimal
      policyCostEUR: null, // decimal
      insuredAmountAutoAcceptationLimitSRD: null,
      insuredAmountAutoAcceptationLimitEUR: null,
      insuredAmountAutoAcceptationLimitUSD: null,
      minInsuredAmountSRD: null,
      maxInsuredAmountSRD: null,
      minInsuredAmountEUR: null,
      maxInsuredAmountEUR: null,
      minInsuredAmountUSD: null,
      maxInsuredAmountUSD: null,
      minInsuredRelations: null,
      maxInsuredRelations: null,
      minBenificiaries: null,
      maxBenificiaries: null,
      allowForeignCurrency: null,
      hasLenderOption: null,
      hasPartialPayment: null,
      prolongationType: null,
      premiumDocumentID: null,
      offerDocumentID: null,
      maxContractDuration: null,
      hasForm: 0,
      hasDurationLimitByAge: 0,
      maxContractAge: null,
    }

    const productsData = ref(JSON.parse(JSON.stringify(blankProductsData)))
    const resetProductsData = () => {
      productsData.value = JSON.parse(JSON.stringify(blankProductsData))
    }

    const onSubmit = () => {
      store.dispatch('apps-products-list/addProduct', productsData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-products-sidebar-active', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetProductsData)

    return {
      productsData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-product-category-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
